<template style="height: 100%;">
  <div class="Userpersonal" v-loading="daochu">
    <el-form class="xforxm" v-if="identity" ref="form" :model="form" label-width="80px">

      <el-form-item :label="$t('original.languages110')">
        <el-input :placeholder="$t('original.languages594')" placeholder-class="placeholder-style" v-model="form.searchData"></el-input>
      </el-form-item>

      <el-form-item :label="$t('original.user_types')" class="nianji">
        <el-select v-model="form.RoleID" :placeholder="$t('original.languages41')">
          <el-option v-for="item in optsssss[0].RoleList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item :label="$t('original.grade')" class="nianji">
        <el-select v-model="form.EntryDate"  :placeholder="$t('original.languages3')">
          <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('original.languages595')" class="nianji">
        <el-select v-model="form.UserActive" :placeholder="$t('original.languages596')">
          <el-option :label="$t('original.languages597')" value="0"></el-option>
          <el-option :label="$t('original.languages598')" value="1"></el-option>
          <el-option :label="$t('original.languages599')" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="单位类型"  style="width: 600px;">
        <el-checkbox style="float: left;margin-right: 20px;" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group :min="1" v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox label="selDepartment" key="selDepartment">培养单位</el-checkbox>
            <el-checkbox label="selTrain" key="selTrain">管理单位</el-checkbox>
          <el-checkbox label="selTeach" key="selTeach">集中教学单位</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <br />
      <el-form-item class="cssoo" style="width: 300px;margin-left: 20px;">
        <el-button type="primary" @click="onSubmit">{{ $t('original.search') }}</el-button>
        <el-button type="primary" @click="resetForm('form')">{{ $t('original.reset') }}</el-button>
        <el-button type="primary" @click="allocation()">{{ $t('original.languages600') }}</el-button>
      </el-form-item>
    </el-form>

    <div v-if="identity">
      <el-button v-if="New_userspd" type="primary" @click="handleClick">{{ $t('original.New_users') }}</el-button>
      <el-button type="primary" @click="uesrexport">{{ $t('original.Export_data') }}</el-button>
    </div>

    <div class="Thelist">
      <div class="Thelist_left" v-if="identity">
        <h2>{{ $t('original.Department_name') }}</h2>
        <el-tree :data="data" class="flow-tree" node-key="value" check-strictly :expand-on-click-node="false" @node-click="check_tree" @node-expand="check_tree" ref="treeForm"></el-tree>
      </div>
      <div class="Thelist_right" :class="{ Thelist_rights: !identity }">
        <h2>{{ $t('original.Student_information') }}</h2>
        <el-table ref="multipleTable" v-loading="load" :element-loading-text="$t('original.languages22')"
          element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%;"
          @selection-change="handleSelectionChange"  @sort-change="sorting" :row-key="(row) => {return row.UserID; }">
          
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
  <!-- :row-key="(row) => { return row.PaperResultID; }" -->
  <!-- :reserve-selection="true" -->
          <el-table-column :label="$t('original.The_serial_number')" width="80px">
            <template slot-scope="scope">{{ (pssndex - 1) * 5 + scope.$index + 1 }}</template>
          </el-table-column>
          
          <el-table-column prop="UserID" :label="$t('original.account')" min-width="60px" sortable></el-table-column>

          <el-table-column prop="RealName" :label="$t('original.name')" min-width="60px"></el-table-column>
          <el-table-column prop="Sex" :label="$t('original.gender')" min-width="40px"></el-table-column>
          <el-table-column prop="Phone" :label="$t('original.phone')" show-overflow-tooltip></el-table-column>
          <el-table-column sortable prop="CreatedDate" :label="$t('original.languages44')" show-overflow-tooltip min-width="100"></el-table-column>
          <el-table-column prop="DeptName" :label="$t('original.Name_of_Company')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="TrainName" :label="$t('original.Name_of_Company2')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="TeachName" :label="$t('original.Name_of_Company3')" show-overflow-tooltip></el-table-column>
          <el-table-column width="80px" :label="$t('original.languages46')">
            <template slot-scope="scope">
              <span v-if="scope.row.FreezeType == '0'">{{ $t('original.languages47') }}</span>
              <span v-else>{{ $t('original.languages48') }}</span>
            </template>
          </el-table-column>
          <el-table-column width="80px" :label="$t('original.languages46s')">
            <template slot-scope="scope">
              <span v-if="scope.row.UserActive == '0'">未激活</span>
              <span v-else-if="scope.row.UserActive == '1'">审核中</span>
              <span v-else-if="scope.row.UserActive == '2'">已激活</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" min-width="120px">
            <template slot-scope="scope">
              
              <span class="caozuo" @click="handleEdit(scope.$index, scope.row)">
                {{ $t('original.languages50') }}
              </span>

              <span class="caozuo" @click="handleDelete(scope.$index, scope.row)" v-if="identity">
                {{ $t('original.languages51') }}
              </span>

              <span class="caozuo" v-if="scope.row.Reset == 1" @click="chongzhi(scope.row)">
                {{ $t('original.languages52') }}
              </span>

              <span class="caozuo" v-if="scope.row.FreezeType == '0'" @click="dongjie(scope.row, 1)">
                {{ $t('original.languages53') }}
              </span>

              <span class="caozuo" v-else @click="dongjie(scope.row, 0)">
                {{ $t('original.languages54') }}
              </span>

            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right;" @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="5" layout="total, prev, pager, next" :total="totalnumber" :hide-on-single-page="wpppd"></el-pagination>
      </div>
    </div>

    <el-drawer :visible.sync="drawer" :with-header="false">
      <div class="basic">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>{{ $t('original.Basic_Information') }}</p>
            </div>
          </el-form-item>

          <el-form-item :label="$t('original.user_types')" prop="RoleID">
            <el-select v-model="ruleForm.RoleIDs" :placeholder="$t('original.languages3')" multiple :disabled="bans">
              <el-option v-for="item in optsssss[0].RoleList" :key="item.key" :label="item.value"  :disabled="item.CanEdit == 1 ? false : true"  :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('original.Name_of_Company')" prop="DeptID">
            <div class="block">
              <el-cascader :data="data" :placeholder="ruleForm.PDeptName" :disabled="bans" ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="ruleForm.DeptID" :options="options" :props="{ checkStrictly: true }" clearable></el-cascader>
            </div>
          </el-form-item>

          <el-form-item :label="$t('original.Name_of_Company2')" prop="TrainID">
            <div class="block">
              <el-cascader :data="data2" :placeholder="ruleForm.TrainName" :disabled="bans" ref="wcascader2" @change="Selected_to_shut_dow2" @expand-change="bumen" v-model="ruleForm.TrainID" :options="options2" :props="{ checkStrictly: true }" clearable></el-cascader>
            </div>
          </el-form-item>

          <el-form-item :label="$t('original.Name_of_Company3')" prop="TeachID">
            <div class="block">
              <el-cascader :data="data3" :placeholder="ruleForm.TeachName" :disabled="bans" ref="wcascader3" @change="Selected_to_shut_dow3" @expand-change="bumen" v-model="ruleForm.TeachID" :options="options3" :props="{ checkStrictly: true }" clearable></el-cascader>
            </div>
          </el-form-item>

          <el-form-item disabled="true" :label="$t('original.account')" prop="UserID">
            <el-input readonly="readonly" v-model="ruleForm.UserID"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.name')" prop="RealName">
            <el-input v-model="ruleForm.RealName"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.grade')" prop="EntryDate">
            <el-select v-model="ruleForm.EntryDate"  :placeholder="$t('original.languages3')">
              <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('original.gender')" prop="Sex">
            <el-radio v-model="ruleForm.Sex" label="1">{{ $t('original.languages5') }}</el-radio>
            <el-radio v-model="ruleForm.Sex" label="0">{{ $t('original.languages6') }}</el-radio>
          </el-form-item>

          <el-form-item :label="$t('original.Date_of_birth')" prop="Birthday">
            <el-date-picker type="date" :placeholder="$t('original.languages3')" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" v-model="ruleForm.Birthday" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('original.phone')" prop="Phone">
            <el-input v-model.trim="ruleForm.Phone"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.mailbox')" prop="Email">
            <el-input v-model.trim="ruleForm.Email"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.Id_number')" prop="IDCard">
            <el-input v-model="ruleForm.IDCard"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.Account_type')" prop="AccountType">
            <el-radio v-model="ruleForm.AccountType" label="2">{{ $t('original.languages7') }}</el-radio>
            <el-radio v-model="ruleForm.AccountType" label="1">{{ $t('original.languages8') }}</el-radio>
          </el-form-item>
          
          <!-- <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>{{ $t('original.Case_information') }}</p>
            </div>
          </el-form-item>

          <el-form-item :label="$t('original.languages56')" prop="ClinicType">
            <el-select v-model="ruleForm.ClinicType" :placeholder="$t('original.languages3')">
              <el-option v-for="item in value3" :key="item.DicKey" :label="item.CDicValue" :value="item.DicKey">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('original.Clinic_date')" prop="ClinicDate">
            <el-date-picker v-model="ruleForm.ClinicDate" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions" :placeholder="$t('original.languages3')"></el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('original.Cases_of_content')" prop="CaseContent">
            <el-input type="textarea" v-model="ruleForm.CaseContent" maxlength="500" show-word-limit></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.note3')" prop="CaseRemark">
            <el-input v-model="ruleForm.CaseRemark"></el-input>
          </el-form-item> -->

          <el-form-item style="width: 100%;">
            <div class="tit" style="margin-left: -80px;">
              <span></span>
              <p>{{ $t('original.languages9') }}</p>
            </div>
          </el-form-item>
          
          <el-form-item :label="$t('original.languages10')" prop="TheGuardian">
            <el-input type="textarea" :rows="2" maxlength="500" show-word-limit v-model="ruleForm.IndividualResume">
            </el-input>
          </el-form-item>
          
          <el-form-item label="婚姻状态">
            <el-select v-model="ruleForm.MarriageState" :placeholder="$t('original.languages3')">
              <el-option v-for="item in value7" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('original.languages11')" prop="TheGuardian">
            <el-input v-model="ruleForm.VideoAccount"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.Admission_time')" prop="TheEntranceDate">
            <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
              v-model="ruleForm.TheEntranceDate" type="date" :placeholder="$t('original.languages3')"></el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('original.The_guardian')" prop="TheGuardian">
            <el-input v-model="ruleForm.TheGuardian"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.Guardian_telephone')" prop="TheGuardianPhone">
            <el-input v-model="ruleForm.TheGuardianPhone"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.Native_place')" prop="NativePlace">
            <el-select v-model="ruleForm.NativePlace" :placeholder="$t('original.languages3')">
              <el-option v-for="item in value24" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('original.national')" prop="Nation">
            <el-select v-model="ruleForm.Nation" :placeholder="$t('original.languages3')">
              <el-option v-for="item in value22" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('original.note2')" prop="SchoolRemark">
            <el-input v-model="ruleForm.SchoolRemark"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.The_serial_number')" prop="LineNumber">
            <el-input v-model="ruleForm.LineNumber"></el-input>
          </el-form-item>

          <!-- <TemplateChild ref="MyChild" @func="getMsgFormSon"></TemplateChild> -->
        </el-form>
        <el-button v-if="!btn_switch" class="btn" @click="tobans" type="primary"> {{ $t('original.languages57') }}</el-button>
        <el-button v-else class="btn" :disabled="csbjb" @click="btn_submit" type="primary">
          {{ $t('original.languages59') }}
        </el-button>
      </div>
    </el-drawer>

    <el-dialog :title="$t('original.languages58')" :visible.sync="wppdialogVisible" width="30%" :before-close="handleClose">
      <el-input v-model="liyou" maxlength="250" type="textarea" resize="none"></el-input>
      <el-button style="margin-top: 20px;" @click="quedingdongjie">{{ $t('original.languages59') }}</el-button>
    </el-dialog>

    <el-dialog title="选择心理委员" class="xsjoijo"  :visible.sync="dialogVisible2" width="30%" :before-close="handleClose">
      <el-select style="width: 300px;" v-model="value1" multiple placeholder="请选择">
        <el-option  v-for="item in woptions" :key="item.UserID" :label="item.RealName" :value="item.UserID">
        </el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 20px;" @click="tianjia()">确定添加</el-button>
    </el-dialog>

  </div>
</template>
<script>
const cityOptions = []
import TemplateChild from '../templates'
export default {
  data() {
    return {
      gradedata:[],
      value7:[],
      New_userspd:false,
      value3: [],
      value22: [],
      value24: [],
      woptions: [],
      value1: [],
      checkedCities: ['selDepartment', 'selTeach', 'selTrain'],
      checkAll: true,
      isIndeterminate: false,
      dialogVisible2: false,
      pdid: true,
      wpppd: true,
      wppdialogVisible: false,
      liyou: '',
      leixing: '',
      renid: '',
      data1: [],
      pssndex: 1,
      pickerOptions: { disabledDate(time) { return time.getTime() > Date.now() - 3600 * 1000 * 24 + 8.64e7 } },
      csbjb: false,
      daochu: false,
      sortingss: '',
      Student_id: '',
      create_time: '',
      totalnumber: 0,
      isAble: false,
      identity: false,
      currentPage1: 1,
      seledeptid: '',
      load: false,
      drawer: false,
      visible: false,
      bans: true,
      btn_switch: true,
      value: '',
      options: [],
      options2: [],
      options3: [],
      data: [],
      data2: [],
      data3: [],
      form: {
        RealName: '',
        UserID: '',
        RoleID: '',
        CreatedDate: '',
        Phone: '',
        pageSize: '5',
        pageIndex: '1',
        EntryDate: '',
        UserActive: '',
        searchData: '',
      },
      ruleForm: {
        MarriageState:'',
        Email: '',
        IndividualResume: '',
        VideoAccount: '',
        LineNumber: '',
        RealName: '',
        RoleIDs: [],
        UserID: '',
        DeptID: '',
        TrainID: '',
        TeachID: '',
        TrainName: '',
        TeachName: '',
        Sex: '1',
        Birthday: '',
        Phone: '',
        IDCard: '',
        AccountType: '2',
        CaseContent: '',
        ClinicDate: '',
        ClinicType: '',
        CaseRemark: '',
        Class: '',
        TheEntranceDate: '',
        TheGuardian: '',
        SchoolRemark: '',
        TheGuardianPhone: '',
        Nation: '',
        NativePlace: '',
        EntryDate: '',
        PDeptName: '',
      },
      optsssss: '',
      rules: {
        Phone: [{ required: true, message: this.$t('original.languages12'), trigger: 'blur' }],
        Email: [{ required: true, message: "请输入邮箱", trigger: 'blur' }],
        IDCard: [{ required: true, message: this.$t('original.languages13'), trigger: 'blur' }],
        RealName: [{ required: true, message: this.$t('original.languages14'), trigger: 'blur' }],
        RoleID: [{ required: true, message: this.$t('original.languages15'), trigger: 'blur' },],
        EntryDate: [{ required: true, message: this.$t('original.languages21'), trigger: 'blur' },],
        DeptID: [{ required: true, message: this.$t('original.languages3'), trigger: 'blur' }],
        TrainID: [{ required: true, message: "请选择管理单位", trigger: 'blur' }],
        TeachID: [{ required: true, message: "集中教学单位", trigger: 'blur' }],
        UserID: [{ required: true, message: this.$t('original.languages17'), trigger: 'blur' }],
        Sex: [{ required: true, message: this.$t('original.languages18'), trigger: 'blur' }],
        Birthday: [{ type: 'date', required: true, message: this.$t('original.languages19'), trigger: 'blur' }],
        AccountType: [{ required: true, message: this.$t('original.languages20'), trigger: 'blur' }],
      },
      tableData: [],
      multipleSelection: [],
    }
  },
  components: {
    TemplateChild: TemplateChild,
  },
  methods: {
    tianjia() {
      if (this.value1) {
        this.$Http_Post('User/saveCommitteeStudents',{ students: this.multipleSelection , committees : this.value1 }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.dialogVisible2 = false;
            this.multipleSelection = [];
            this.value1 = [];
          }
        })
      } else {
        alert("请选择心理委员")
      }

      

      
    },
    allocation() {

      if (this.multipleSelection.length >= 1) {
        this.$Http_Post('User/GetCommitteeList',).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.dialogVisible2 = true
            this.woptions = res.Data.Lists
          } else {
          }
        })
      } else {
        alert("请选择人员")
      }

      
    },
    handleCheckAllChange(val) {
      if (val) {
        this.checkedCities = ['selDepartment', 'selTeach', 'selTrain']
        this.isIndeterminate = false;
      } else {
        // this.isIndeterminate = true;
        this.checkedCities = ['selDepartment', 'selTeach', 'selTrain']
        this.checkAll = true;
      }
    },
    handleCheckedCitiesChange(value) {
      this.checkedCities = value;
      if (value.length >= 3) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
    Selected_to_shut_dow(dt) {
      this.ruleForm.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    Selected_to_shut_dow2(dt) {
      this.ruleForm.TrainID = dt[dt.length - 1];
      this.$refs.wcascader2.dropDownVisible = false;
    },
    Selected_to_shut_dow3(dt) {
      this.ruleForm.TeachID = dt[dt.length - 1];
      this.$refs.wcascader3.dropDownVisible = false;
    },
    quedingdongjie() {
      this.$Http_Post('User/ThawFrozen', { UserID: this.renid, FreezeType: this.leixing, FreezeThe: this.liyou }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.wppdialogVisible = false;
          this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time,this.checkedCities);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleClose(done) {
      this.$confirm(this.$t('original.languages60')).then((_) => {
        done();
      })
      .catch((_) => { })
    },
    dongjie(val, id) {
      this.wppdialogVisible = true;
      this.renid = val.UserID;
      this.leixing = id;
    },
    chongzhi(val) {
      this.$Http_Post('User/ResetPassword', { UserID: val.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
        } else {
          this.Global.request_failure(res.Message);
        }
      },)
    },
    getMsgFormSon(data) {
      this.msgFormSon = data;
    },
    sorting({ column, prop, order }) {
      if (prop == 'UserID') {
        this.Student_id = order;
        this.create_time = '';
        this.sortingss = '';
      } else if (prop == 'CreatedDate') {
        this.create_time = order;
        this.Student_id = '';
        this.sortingss = '';
      } else if (prop == 'LineNumber') {
        this.sortingss = order;
        this.Student_id = '';
        this.create_time = '';
      }
      this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time, this.checkedCities);
    },
    onSubmit() {
      this.form.pageIndex = 1;
      this.currentPage1 = 1;
      this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time, this.checkedCities);
    },
    check_tree(dt, obj, node) {
      if (dt.fuzi && dt.children.length > 0 && dt.children[0].DeptID == '-1') {
        dt.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt.DeptID, content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data) {
              dt.children = res.Data;
            }
          }
        })
      }
      this.arr = [dt.value];
      this.types = '2';
      this.seledeptid = dt.value;
      this.form.pageIndex = '1';
      this.currentPage1 = 1;
      this.loading(this.form, dt.value, this.sortingss, this.Student_id, this.create_time, this.checkedCities);
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.options[0];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i]
          break
        } else if (this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.options[i].children,
          )
        }
      }
      let _this = this
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data
          }
        })
      }
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.loading(this.form,this.seledeptid,this.sortingss,this.Student_id,this.create_time,this.checkedCities);
    },
    handleSizeChange(val) {
      
    },
    resetForm(formName) {
      this.form.RealName = '',
      this.form.UserID = '',
      this.checkedCities = ['selDepartment','selTeach','selTrain'],
      this.form.EntryDate = '',
      this.form.RoleID = '',
      this.form.CreatedDate = '',
      this.form.Phone = '',
      this.form.searchData = '',
      this.form.UserActive = '',
      this.form.RealName = '',
      this.form.RealName = '',
      this.form.pageIndex = 1,
      this.loading(this.form, '', this.sortingss, this.Student_id, this.create_time, this.checkedCities),
      this.currentPage1 = 1
    },
    uesrexport() {
      this.daochu = true;
      this.$Http_Post('User/ExportUserData', { from: this.form, Language: 'Chinese', selBox: this.checkedCities }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.daochu = false;
          this.Global.request_successful(res.Message);
          window.location.href = res.Data;
        } else {
          this.daochu = false;
          this.Global.request_failure(res.Message);
        }
      })
    },

    btn_submit() {
      if (this.msgFormSon) {
        if (this.msgFormSon.dropListInfo.length > 0) {
          var csi = this.msgFormSon.dropListInfo;
          var lkokjcid = this.ruleForm;
          for (var i = 0; i < csi.length; i++) {
            lkokjcid[csi[i].Control] = csi[i].ControlValue;
          }
          this.ruleForm = lkokjcid;
        }
        if (this.msgFormSon.textBoxInfo.length > 0) {
          var cs2i = this.msgFormSon.textBoxInfo;
          var lkokjecid = this.ruleForm;
          for (var i = 0; i < cs2i.length; i++) {
            lkokjecid[cs2i[i].Control] = cs2i[i].ControlValue;
          }
          this.ruleForm = lkokjecid;
        }
      }
      this.csbjb = true;
      this.$Http_Post('User/UpdateUser', this.ruleForm).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.nav_list = res.Data;
          this.Global.request_successful(res.Message);
          this.drawer = false;
          this.csbjb = false;
          this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time, this.checkedCities);
        } else {
          this.Global.request_failure(res.Message);
          this.csbjb = false;
        }   
      })
    },
    tobans() {
      this.bans = false;
    },
    handleClick() {
      this.$router.push({ path: '/user/User_add' });
    },
    handleSelectionChange(val) {
      var cjdjcd = [];
      for (var i = 0; i < val.length; i++) {
        cjdjcd.push(val[i].UserID);
      }
      this.multipleSelection = cjdjcd;
    },
    handleEdit(index, row) {
      if (this.Global.pdroleid(1057) || this.Global.pdroleid(1063) || this.Global.pdroleid(1089) ||this.Global.pdroleid(1083)) {
        this.bans = false;
      } else {
        this.bans = true;
      }
      this.$Http_Post('User/GetUpdateUser', { UserID: row.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.load = false,
          this.drawer = true,
          this.ruleForm.MarriageState = res.Data.MarriageState,
          this.ruleForm.IndividualResume = res.Data.IndividualResume,
          this.ruleForm.VideoAccount = res.Data.VideoAccount,
          this.ruleForm.RoleIDs = res.Data.RoleIDs,
          this.ruleForm.UserID = res.Data.UserID,
          this.ruleForm.EntryDate = res.Data.EntryDate,
          this.ruleForm.RealName = res.Data.RealName,
          this.ruleForm.Sex = res.Data.Sex,
          this.ruleForm.Birthday = res.Data.Birthday,
          this.ruleForm.AccountType = res.Data.AccountType,
          this.ruleForm.ClinicType = res.Data.ClinicType,
          this.ruleForm.ClinicDate = res.Data.ClinicDate,
          this.ruleForm.CaseContent = res.Data.CaseContent,
          this.ruleForm.Phone = res.Data.Phone,
          this.ruleForm.IDCard = res.Data.IDCard,
          this.ruleForm.CaseRemark = res.Data.CaseRemark,
          this.ruleForm.DeptID = res.Data.DeptID,
          this.ruleForm.TrainID = res.Data.TrainID,
          this.ruleForm.TeachID = res.Data.TeachID,
          this.ruleForm.TrainName = res.Data.TrainName,
          this.ruleForm.TeachName = res.Data.TeachName,
          this.ruleForm.TheEntranceDate = res.Data.TheEntranceDate,
          this.ruleForm.TheGuardian = res.Data.TheGuardian,
          this.ruleForm.SchoolRemark = res.Data.SchoolRemark,
          this.ruleForm.TheGuardianPhone = res.Data.TheGuardianPhone,
          this.ruleForm.Nation = res.Data.Nation,
          this.ruleForm.NativePlace = res.Data.NativePlace,
          this.ruleForm.LineNumber = res.Data.LineNumber,
          this.ruleForm.PDeptName = res.Data.DeptName,
          this.ruleForm.Email = res.Data.Email,
                     this.$nextTick(() => { this.$refs.MyChild.RefushData(res.Data) })
        } else {
          this.$notify.error({ title: '错误', message: res.Message })
        }
      },)
    },
    handleDelete(index, row) {//删除
      this.$confirm(this.$t('original.languages62'), this.$t('original.languages63'), { confirmButtonText: this.$t('original.languages59'), cancelButtonText: this.$t('original.cancel'), type: 'warning', showClose: false, closeOnClickModal: false, }).then(() => {
        this.$Http_Post('User/DeleteUser', { UserID: row.UserID }).then((res) => {
          this.$notify.closeAll();
          if (res.Code == 200 || res.Code == 0) {
            this.$notify({ title: this.$t('original.languages167'), message: res.Message, type: 'success', })
            this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time, this.checkedCities)
          } else {
            this.$notify.error({
              title: this.$t('original.languages168'),
              message: res.Message,
            })
          }
        },
        )
      })
    },
    loading(from, seledeptid, sortingss, id_ascending, data_ascending, selBox) {
      this.pssndex = from.pageIndex;
      this.load = true;
      this.$Http_Post('User/GetUserList', { 
        from, 
        seledeptid: seledeptid, 
        sort: sortingss, 
        idsort: id_ascending, 
        datasort: data_ascending, 
        selBox: selBox }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.load = false;
          if (res.Data.Counts >= 5) { this.wpppd = false } else { this.wpppd = true }
          if (res.Data.Lists.length > 0) {
            this.tableData = res.Data.Lists;
            this.totalnumber = Number(res.Counts);
            this.isAble = true;
            setTimeout(function () {
              this.isAble = false;
            }, 2000)
          } else {
            this.load = false;
            if (Number(from.pageIndex) > 1) {
              from.pageIndex = from.pageIndex - 1;
              this.currentPage1 = this.currentPage1 - 1;
              this.loading(this.form, this.seledeptid, this.sortingss, this.Student_id, this.create_time, this.checkedCities);
            } else {
              this.tableData = res.Data.Lists;
              this.totalnumber = Number(res.Counts);
            }
          }
        } else {
          this.$notify.closeAll();
          this.$notify.error({ title: this.$t('original.languages168'), message: res.data.Message });
        }
      })
    },
  },

  created() {
  },

  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 13 }).then((res) => {
      if (res.Code == 0) {
        this.value7 = res.Data;
        console.log(this.value7)
      }
    })
    if (this.Global.pdroleid(1057)||this.Global.pdroleid(1083)) {
      this.New_userspd = true;
    } else {
      this.New_userspd = false;
    }
    this.$Http_Post('User/GetUserType').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.optsssss = res.Data;
        this.form.RoleID = res.Data[0].RoleList[1].key;
      }
    })
    var date = new Date();
    this.identity = this.Global.identity;
    if(this.Global.pdroleid(1083)){
      this.identity=true;//jypxgly 教育培训管理员放开用户导入权限
    }
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      this.options = res.Data;
      this.options2 = res.Data;
      this.options3 = res.Data;
      if (res.Data) { this.data = res.Data; }
    })
    this.$Http_Post('User/GetDictionaryList',{ DicTypCode :27 }).then((res) => {
      if (res.Code == 0) {
        this.value = res.Data;
      } else {
        this.$notify.closeAll(); this.$notify.error({ title: this.$t('original.languages168'), message: res.Message })
      }
    })
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 6 }).then((res) => {
      if (res.Code == 0) {
        this.value3 = res.Data;
      }
    })
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 24 }).then((res) => {
      if (res.Code == 0) {
        this.value24 = res.Data;
      }
    })
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 22 }).then((res) => {
      if (res.Code == 0) {
        this.value22 = res.Data;
      }
    })
    var _this = this
    setTimeout(function () {
      _this.loading(_this.form, '', _this.sortingss, _this.Student_id, _this.create_time, _this.checkedCities);
    },200)
  },
}
</script>
<style>
.Userpersonal {
  height: 100%;
  min-height: 735px;
}
.Userpersonal input::-webkit-input-placeholder { 
    /* WebKit browsers */ 
    font-size:12px;
} 
.Userpersonal input::-moz-placeholder { 
    /* Mozilla Firefox 19+ */ 
    font-size:12px;
} 
.Userpersonal input:-ms-input-placeholder { 
    font-size:12px;

}


.Userpersonal .xforxm .el-form-item {
  margin-bottom: 10px;
  float: left;
  width: 25%;
}

.Userpersonal .el-form .el-form-item .el-form-item__label {
  width: 100px !important;
}

.Userpersonal .el-input__inner {
  height: 36px;
}

.Userpersonal .el-form .el-form-item .el-input {
  width: 80% !important;
}

.Userpersonal .el-form .el-form-item .el-date-editor {
  width: 80%;
}

.Userpersonal .el-form .el-form-item .el-select {
  width: 80%;
}

.Userpersonal .basic .el-select {
  width: 100% !important;
}

.Userpersonal .el-form .el-form-item .el-select .el-input {
  width: 100%;
}

.Userpersonal .xforxm {
  height: 106px;
}

.caozuo {
  margin-left: 10px;
  color: #409eff;
  cursor: pointer;
}

.Userpersonal .basic>h2 {
  font-size: 16px;
}

.Userpersonal .basic {
  width: 100%;
  margin-left: -10px;
  height: 1400px;
}

.Userpersonal .basic .tit span {
  width: 3px;
  height: 20px;
  background-color: rgba(0, 136, 255, 1);
  display: inline-block;
  position: absolute;
  left: 0px;
  top: 0px;
}

.Userpersonal .basic .tit p {
  position: absolute;
  left: 10px;
  top: -9px;
}

.Userpersonal .basic .tit {
  position: relative;
  margin-top: 16px;
  height: 30px;
  margin-left: 20px;
}

.Userpersonal .basic .el-textarea textarea {
  height: 80px;
}

.Userpersonal .btn {
  margin-left: 42%;
  margin-bottom: 50px;
}

.el-drawer__open .el-drawer.rtl {
  -webkit-animation: rtl-drawer-in 0.3s 1ms;
  animation: rtl-drawer-in 0.3s 1ms;
  width: 40% !important;
}

.Userpersonal .basic .el-form {
  margin-left: 20px;
  width: 80%;
}

.Userpersonal .basic .el-cascader {
  display: inline-block;
  position: relative;
  font-size: 14px;
  line-height: 40px;
  width: 100%;
}

.Userpersonal .Thelist_left {
  width: 300px;
  border: 1px solid rgba(225, 226, 227, 1);
  margin-top: 15px;
  float: left;
  height: calc(100% - 50px);
}

.Userpersonal .Thelist_left h2 {
  padding: 18px;
  font-size: 18px;
}

.Userpersonal .Thelist_right {
  width: calc(100% - 325px);
  border: 1px solid rgba(225, 226, 227, 1);
  float: right;
  margin-top: 15px;
}

.Userpersonal .Thelist_rights {
  width: calc(100% - 2px);
}

.Userpersonal .Thelist_right h2 {
  padding-top: 18px;
  padding-left: 10px;
  font-size: 18px;
}

.Userpersonal .Thelist {
  width: 100%;
  height: 88%;
}

.Userpersonal .cssoo .el-form-item__content {
  margin-left: 0px !important;
}

.Userpersonal .el-textarea .el-input__count {
  height: 20px;
  bottom: 12px;
}

.Userpersonal .el-table .cell {
  text-align: center;
}

.Userpersonal .el-tree {
  min-width: 280px;
}

.nianji .el-form .el-form-item .el-input {
  width: 100% !important;
}

.Userpersonal .el-form .nianji .el-input {
  width: 100% !important;
}

.flow-tree {
  overflow: auto;
  height: calc(100% - 70px);
  margin: 10px;
}

.el-tree-node>.el-tree-node__children {
  overflow: visible !important
}

.Userpersonal .xsjoijo .el-dialog{height: 200px;}
</style>
